{
  "questions": {
    "culture": {
      "detailsPlaceholder": "<p>Tēnā tuhi mai ki te reo Ingarihi. Hei tauira:</p>\n<p>Whānau to be present, need interpreter, specific dietary customs</p>",
      "label": "He hiahia ahurea, ā-whānau rānei āu?",
      "nextLabel": "$t(common:next): <b>Ētahi atu hiahia motuhake, pārongo rānei</b>",
      "title": "<h3>Ngā hiahia ahurea, ā-whānau rānei</h3>"
    },
    "language": {
      "de": "Deutsch / German",
      "detailsLabel": "He aha tō reo pai?",
      "fj": "Vosa Vakaviti / Fijian",
      "fr": "Français / French",
      "ja": "日本語 / Japanese",
      "ko": "한국어 / Korean",
      "label": "He uaua ki a koe te mārama ki te reo Pākehā?",
      "mi": "Te Reo Māori",
      "ms": "Malay / Malaysian",
      "nextLabel": "$t(common:next): <b>Ngā hiahia whakapono, wairua rānei</b>",
      "other": "Ētahi atu",
      "pt": "Português / Portuguese",
      "sm": "Gagana Samoa / Samoan",
      "ta": "தமிழ் / Tamil",
      "title": "<h3>Te mārama ki te reo Ingarihi</h3>",
      "tl": "Tagalog / Tagalog",
      "to": "Lea Faka-Tonga / Tongan",
      "zh": "简体中文 / Chinese"
    },
    "mobility": {
      "detailsPlaceholder": "Tēnā whakakīia ki te reo Pākehā. Hei tauira:<br/>Ka whakamahi tōrino, tūru wīra rānei; me āwhina ki te neke ki te moenga",
      "label": "He hauā tōu, he hiahia āwhina rānei mō te nekehanga?",
      "nextLabel": "$t(common:next): <b>Te mārama ki te reo Ingarihi</b>",
      "title": "<h3>Te āheinga neke</h3>"
    },
    "other": {
      "detailsPlaceholder": "Tūhonoa ngā mea e whakaaro ana koe he mea hira. Mā tēnei e pai ake ai tā mātou tautoko i a koe.",
      "label": "He hiahia motuhake anō āu, he mōhiohio rānei e hiahia ana koe kia mōhiotia e mātou?",
      "nextLabel": "$t(common:next): <b>Te tiki i tō rongoā whakarite puku</b>",
      "title": "<h3>Ētahi atu hiahia motuhake, pārongo rānei</h3>"
    },
    "prep": {
      "label": "Tīpakohia te āhua e hiahia ana koe ki te whiwhi i tēnei:",
      "nextLabel": "$t(common:next): <b>Whakaoti tāu tāpui</b>",
      "pick-up-from-hospital": "<label>Tīkina mai i te {{company}}</label>\n<p>Tīkina tō mōkihi whakarite i te rūma whakatau i ngā hāora whakatuwhera.</p>",
      "pick-up-from-local-pharmacy": "<label>Tīkina mai i tō whare rongoā kāinga</label>\n<p>Ka tukuna mā te īmēra he rongoā kua tohua e mātou hei kawe māu ki tō whare rongoā.</p>",
      "receive-by-mail": "<label>Whiwhi mā te mēra</label>\n<p>Ka tukuna mā te kaikawe tō mōkihi whakarite ki te wāhi noho i hoatu e koe.</p>",
      "text": "Hei whakarite mō tāu pokanga, me inu koe i tētahi rongoā motuhake hei whakakore i tō kōpū.",
      "title": "<h3>Te tiki i tō rongoā kōpū</h3><p>Hei whakarite mō tāu pokanga, me inu koe i tētahi rongoā motuhake hei whakakore i tō kōpū.</p>"
    },
    "religion": {
      "detailsPlaceholder": "<p>Tēnā whakakīhia mā te reo Ingarihi. Hei tauira:<br/>Quiet space for prayer, prefer same-gender staff for personal care</p>",
      "label": "He hiahia whakapono, wairua rānei āu?",
      "nextLabel": "$t(common:next): <b>Ngā hiahia ahurea, whānau hoki</b>",
      "title": "<h3>Ngā hiahia whakapono, wairua hoki</h3>"
    }
  }
}
